module.exports = Jsw.skinUrl + "/images/indicator.gif?ece6f747d3bfdc48d99f935627535c09";